import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useContext } from "react";
import { theme as rootTheme } from "../theme";
export const ThemeContext = createContext(undefined);
export const ThemeProvider = ({ theme, children }) => {
    return _jsx(ThemeContext.Provider, { value: theme, children: children });
};
export const useTheme = () => {
    const theme = useContext(ThemeContext);
    if (!theme) {
        console.error("Theme context only available within ThemeProvider. Falling back to root theme.");
        return rootTheme;
    }
    return theme;
};
//# sourceMappingURL=ThemeProvider.js.map